import {
    UrlSubdirectoryTypes,
    LocationType,
    ResultType,
    selectResultType,
    selectLocationType
} from "features/searchResultsFacets";
import PageType from 'enums/pageType';
import { store } from '@redux/store';

function getTrackerName() {
  const nhsTrackingId = 'UA-40843711-4';
  const trackers = window.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
  const tracker = trackers[0].get('name');
  return tracker;
}

function getTrackerClientId() {
  const nhsTrackingId = 'UA-40843711-4';
  const trackers = window.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
  const clientId = trackers[0].get('clientId');
  return clientId
}

/**
 * A function that returns the value of the page type to be tracked in Google Analytics custom dimensions.
 * For instance, in Homes searches it will return `Home_Results`; in Single Family cases `Single_Family_Homes`.
 * For state pages, it returns the appropriate page type based on the result type
 * @param {string} page - The page subdirectory key.
 * @param {string} locationType - Optional location type to determine if it's a state page.
 * @returns {string} The page type string.
 */
const getPageType = (page, locationType) => {
  // Get locationType from Redux store if not provided
  const state = locationType ? null : store.getState();
  const currentLocationType = locationType || selectLocationType(state);

  // Check if this is a state page by checking locationType first
  // State pages can have URLs like /communities/tx or /homes/tx, so we rely on locationType
  if (currentLocationType === LocationType.State.toString()) {
    const resultTypeFromUrl = ResultType.fromKey(page)?.toString();
    const getResultTypeFromState = !resultTypeFromUrl;
    const stateForResultType = getResultTypeFromState
      ? (state || store.getState())
      : null;
    const resultType = resultTypeFromUrl || selectResultType(stateForResultType);

    if (resultType === ResultType.Communities.toString()) {
      return PageType.CommunitiesState.toString();
    }

    if (resultType === ResultType.Homes.toString()) {
      return PageType.HomesState.toString();
    }

    return PageType.State.toString();
  }

  // For non-state pages, use the existing logic
  return UrlSubdirectoryTypes.fromKey(page)?.pageType || '';
};

export { getTrackerName, getPageType, getTrackerClientId };
